import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { useAuthStore } from '@/store/authStore'
import { ROUTES } from '@/constants'
import { authService } from '@/services/firebase/auth'

const ProtectedRoute = () => {
  const { isAuthenticated, user, setUser, setLoading } = useAuthStore()
  const location = useLocation()

  useEffect(() => {
    const unsubscribe = authService.onAuthStateChanged(async (firebaseUser) => {
      if (firebaseUser) {
        try {
          const profile = await authService.getUserProfile(firebaseUser.uid)
          if (profile) {
            setUser(profile)
          } else {
            // No Firestore profile yet (new user or Firestore unavailable) — allow access with minimal profile
            setUser({
              id: firebaseUser.uid,
              uid: firebaseUser.uid,
              phoneNumber: firebaseUser.phoneNumber ?? '',
              name: firebaseUser.displayName ?? 'User',
              role: 'engineer',
              isActive: true,
              createdAt: new Date(),
              updatedAt: new Date()
            })
          }
        } catch {
          // Firestore error — still allow access if Firebase Auth says user is signed in
          setUser({
            id: firebaseUser.uid,
            uid: firebaseUser.uid,
            phoneNumber: firebaseUser.phoneNumber ?? '',
            name: firebaseUser.displayName ?? 'User',
            role: 'engineer',
            isActive: true,
            createdAt: new Date(),
            updatedAt: new Date()
          })
        }
      } else {
        setUser(null)
      }
      setLoading(false)
    })

    return () => unsubscribe()
  }, [setUser, setLoading])

  if (!isAuthenticated) {
    // Redirect to login, but save the location they tried to access
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />
  }

  if (!user?.isActive) {
    // User account is disabled
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="text-center">
          <h1 className="text-xl font-semibold text-gray-900 mb-2">
            Account Inactive
          </h1>
          <p className="text-gray-600">
            Your account has been disabled. Please contact support.
          </p>
        </div>
      </div>
    )
  }

  return <Outlet />
}

export default ProtectedRoute
